import makePage from 'modules/makePage';
import lazyWithSuspense from 'modules/lazyWithSuspense';
import Page from 'modules/Page';
import { i18n } from 'i18n';
import * as parentConstants from 'modules/user-admin/UsersAreaPage/constants';
import * as constants from './constants';
import { UserDetailsPageParams } from './constants';
import useUserDetailsQueries, { UserDetailsQueries } from './useUserDetailsQueries';

const UserDetailsPage = lazyWithSuspense(() => import('./UserDetailsPage'));

const page: Page = {
  title: constants.TITLE,
  routeProps: {
    path: constants.ROUTE_PATH,
  },
  admin: true,
  component: makePage<UserDetailsPageParams, UserDetailsQueries>({
    WrappedPage: UserDetailsPage,
    titleFn: ([user]) => (user.data ? `${user.data.forename} ${user.data.surname}` : ''),
    parentPathTemplate: parentConstants.USER_ACCOUNTS_ROUTE_PATH,
    parentTitleFn: () => i18n._(parentConstants.TITLE),
    pageDataHook: useUserDetailsQueries,
  }),
};

export default page;
